import { callGetApiToServer } from "../callApi";

export async function getAllSearchSubUser(
  authtoken,
  searchText,
  skipNumber,
  limitNumber
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl =
      "v1/auth/list/sub-user/" +
      skipNumber +
      "/" +
      limitNumber +
      "/" +
      searchText;

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
